import { Center, HStack, Text, VStack } from "@chakra-ui/layout";
import { Card, Spinner, useMediaQuery } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { ProfitRow } from "@src/components/modules/projects/detail/Evaluation/Profit";
import { CardHeader } from "@src/components/modules/projects/detail/Stats/CardHeader";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import type { ProfitSummaryProps } from "../../summary/profit";
import { PieList } from "../pie-list";

type Props = Omit<ProfitSummaryProps, "type"> & {
  isResponsive?: boolean;
};

export const ProfitCard = observer(function ProfitCard({
  summary,
  isFetching,
  expenseBudgetCategories,
  isResponsive,
}: Props) {
  const [isLargerThan1513] = useMediaQuery("(min-width: 1513px)");

  return (
    <Card p="4" bg="grey.50">
      {!summary || isFetching ? (
        <Center minH="32">
          <Spinner size="xl" />
        </Center>
      ) : (
        <HStack spacing="4" w="full" align="start">
          <VStack
            align="start"
            w={!isResponsive ? "full" : isLargerThan1513 ? "60%" : "75%"}
          >
            <HStack
              alignItems="flex-start"
              justifyContent="space-between"
              w="full"
            >
              <CardHeader title={t`Profit`} />
              <HStack spacing="4">
                <Text fontSize="2xl" fontWeight="bold">
                  {currency.formatByWorkspace(
                    summary.gross_profit_for_date_range,
                  )}
                </Text>
              </HStack>
            </HStack>
            <ProfitRow
              title={t`Work`}
              value={summary.our_work_revenue_for_date_range}
              percentValue={summary.our_work_revenue_for_date_range_percentage}
            />
            {expenseBudgetCategories.map((category) => {
              const profit = summary.expense_revenue_for_date_range.find(
                (revenue) => revenue.category.id === category.id,
              );

              return profit ? (
                <ProfitRow
                  title={profit.category.name}
                  value={profit.profit}
                  percentValue={profit.profit_percentage}
                  key={`profit-${profit.category.name}`}
                />
              ) : null;
            })}
          </VStack>
          <PieList
            isResponsive={isResponsive}
            data={summary.brand_profit_share ?? []}
            title={t`Share Profit (by Brand)`}
            pieHeight="28"
          />
        </HStack>
      )}
    </Card>
  );
});
